/** 用户明确在 Tron 目标下关闭「自定义地址」、改用钱包默认展示时写入，会话内记住 */
const KEY = 'hieswap_tron_receive_prefer_default'

export function getTronPreferDefaultWallet() {
  try {
    return sessionStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}

export function setTronPreferDefaultWallet(on) {
  try {
    if (on) sessionStorage.setItem(KEY, '1')
    else sessionStorage.removeItem(KEY)
  } catch {
    void 0
  }
}
